import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Notifications Icon for Lyra Connect navigation (bell icon)
 */
export const ConnectNotificationsIcon: FunctionComponent<ConnectNotificationsIconProps> = ({
  size = 24,
  fillColor,
}) => {
  const { colors } = useTheme()
  return (
    <Svg width={size} height={size} viewBox='0 0 40 40' fill='none'>
      <Path
        d='M23.3335 32.917C23.3333 34.75 21.8335 36.2498 20.0005 36.25C18.1506 36.25 16.6666 34.7502 16.6665 32.917H23.3335ZM20.0005 3.75C21.3836 3.75022 22.5005 4.8668 22.5005 6.25V7.38379C27.2668 8.5173 30.0005 12.8005 30.0005 17.917V26.25L32.1499 28.4004C33.1997 29.4504 32.4662 31.25 30.9663 31.25H9.01705C7.53381 31.25 6.80034 29.4504 7.85006 28.4004L10.0005 26.25V17.917C10.0005 12.7837 12.7171 8.51712 17.5005 7.38379V6.25C17.5005 4.86667 18.6171 3.75 20.0005 3.75ZM20.0005 10.417C15.8505 10.417 13.3335 13.7837 13.3335 17.917V27.917H26.6665V17.917C26.6665 13.7838 24.1502 10.4172 20.0005 10.417Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}

export type ConnectNotificationsIconProps = {
  size?: number
  fillColor?: string
}
